export const ADD_ITEM = "ADD_ITEM";
export const INC_QUANTITY = "INC_QUANTITY";
export const DEC_QUANTITY = "DEC_QUANTITY";

export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAILED = "AUTH_FAILED";
export const AUTH_LOGOUT = "AUTH_LOGOUT"

export const ORDER_SUCCESS = "ORDER_SUCCESS";
export const INIT_PRICE = "INIT_PRICE";


// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js